'use client'

import { Button } from '@/components/ui/button'
import { useHeaderNavigationContext } from '@/providers/HeaderNavigation'
import { cn } from '@/utilities/ui'

const MENU_BUTTON_CLASSES =
  'relative ml-1 flex lg:hidden size-11 items-center justify-center rounded-xl! border border-transparent p-1 opacity-100 transition-all duration-300'

const MenuIcon: React.FC = () => {
  const { isMenuOpen } = useHeaderNavigationContext()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="size-6"
    >
      <line
        x1="4"
        x2="20"
        y1="12"
        y2="12"
        className={cn('origin-center transition-transform duration-300', isMenuOpen && 'rotate-45')}
      ></line>
      <line
        x1="4"
        x2="20"
        y1="6"
        y2="6"
        className={cn('origin-center transition-all duration-300', isMenuOpen && 'opacity-0')}
      ></line>
      <line
        x1="4"
        x2="20"
        y1="18"
        y2="18"
        className={cn(
          'origin-center transition-transform duration-300',
          isMenuOpen && '-translate-1 -rotate-45',
        )}
      ></line>
    </svg>
  )
}

export const MenuButton: React.FC = () => {
  const { colorInverse, isMenuOpen, setIsMenuOpen } = useHeaderNavigationContext()

  return (
    <Button
      className={cn(
        MENU_BUTTON_CLASSES,
        colorInverse && !isMenuOpen
          ? 'bg-background text-primary [&>span]:text-primary'
          : 'bg-accent text-background [&>span]:text-background',
      )}
      onClick={() => setIsMenuOpen(!isMenuOpen)}
      aria-label="Open menu"
      aria-expanded={isMenuOpen}
      aria-controls="nav-mobile"
      aria-haspopup="menu"
      icon={false}
    >
      <MenuIcon />
    </Button>
  )
}
